import React, { useState, useEffect } from 'react';

import Primarytheme from './utility/theme';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';

import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import CloseIcon from '@mui/icons-material/Close';

import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Snackbar } from '@mui/material';

import { styled } from '@mui/material/styles';

import { Grid, Typography, Stack, Checkbox, FormControlLabel, FormGroup, Select, MenuItem, ListItemText, OutlinedInput } from '@mui/material';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import ProjectParameters from './utility/ProjectParameters';
import ProjectDisable from './utility/ProjectDisable';

import { getSessionIdToken } from './auth/apiAuth'

import axios from 'axios';

const { buildUsernameFromEmail } = require('./auth/utils-auth');


const POLICY_OPTIONS = [
    { key: 'canDelete', label: 'Can Delete' },
    { key: 'canLaunch', label: 'Can Launch' },
    { key: 'canManageAsset', label: 'Can Manage Asset' },
    { key: 'filterUser', label: 'Filter User' },
    { key: 'canManageGeoxRules', label: 'Can Manage Geox Rules' },
    { key: 'canManageIntegrations', label: 'Can Manage Integrations' },
    { key: 'canManagePaginationAPI', label: 'Can Manage Pagination API' },
    { key: 'canManageLabels', label: 'Can Manage Labels' },
];

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'left',
    color: Primarytheme.palette.primary.main,
    fontSize: '16px',
    fontWeight: 'bold',
    background: 'white',
    border: '1px',
    minWidth: 950
}));



const {
    REACT_APP_USER_ID,
    REACT_APP_USER_POOL_ID,
} = process.env;




export default function Administration({ auth }) {

    const [projects, setProjects] = useState({ list: [], labelsProjectsList: [], retrieving: true, });


    const [userMngmt, setUserMngmt] = useState({
        email: '',
        customer: '',
        isAdmin: false,
        type: '',
        policy: {
            canDelete: true,
            canLaunch: true,
            canManageAsset: true,
            filterUser: false,
            canManageGeoxRules: false,
            canManageIntegrations: false,
            canManagePaginationAPI: false,
            canManageLabels: false,
        },
        attached_labels_projects: [],
        //attached_project_ids: [],
        isCreating: false,
        created: false,
        selectedList: []
    })

    const [patchUsrMngmt, setPatchUsrMngmt] = useState({

        email: '',
        customer: '',
        attached_projects: [],
        selectedList: [],
        isAdmin: false,
        type: '',
        policy: {
            canDelete: false,
            canLaunch: false,
            canManageAsset: false,
            filterUser: false,
            canManageGeoxRules: false,
            canManageIntegrations: false,
            canManagePaginationAPI: false,
            canManageLabels: false,
        },
        attached_labels_projects: [],
        registrationDate: undefined,
        lastLogin: undefined,
        isFetching: false,
        fetched: false,
        isPatching: false,
        patched: false,
        openDelete: false,
    })

    const [customerFilter, setCustomerFilter] = useState({
        customer: auth.userState.isAdmin ? 'pagination' : '', // filtro qui di default a pagination, ma anche nell'autocomplete è default a quel valore
        isFetching: false,
        fetched: false,
        users: []
    })

    const [snack, setSnack] = useState({
        open: false,
        creationMessage: ''
    })

    const handleClickOpen = () => {
        setPatchUsrMngmt({ ...patchUsrMngmt, openDelete: true });
    };

    const handleAgree = (action) => {
        setPatchUsrMngmt({ ...patchUsrMngmt, openDelete: false });
        patchUser(action)
    };
    const handleDisagree = () => {
        setPatchUsrMngmt({ ...patchUsrMngmt, openDelete: false });
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnack({
            open: false,
            creationMessage: ''
        });
    };

    const handleCustomerFilter = (event, value, reason) => {
        if (reason === 'clear') handleResetCustomerPatch();
        else {
            setCustomerFilter({ ...customerFilter, customer: value, users: [] })
            handleResetUserPatch()
        }
    }
    const handleSelectPathEmail = (event, value, reason) => {
        if (reason === 'clear') handleResetUserPatch()
        else {
            setPatchUsrMngmt({
                ...patchUsrMngmt, email: value.email, retrieving: true
            })
            getUserInfo(value.email)
                .then(response => {
                    //console.log(response.data);
                    const userData = response.data;
                    setPatchUsrMngmt({
                        ...patchUsrMngmt,
                        retrieving: false,
                        email: value.email,
                        selectedList: userData.attached_projects,
                        fetched: true,
                        attached_projects: userData.attached_projects,
                        isAdmin: userData.type === 'administrator',
                        type: userData.type,
                        policy: {
                            canDelete: userData.policy.hasOwnProperty('canDelete') ? userData.policy.canDelete : true,
                            canLaunch: userData.policy.hasOwnProperty('canLaunch') ? userData.policy.canLaunch : true,
                            canManageAsset: userData.policy.hasOwnProperty('canManageAsset') ? userData.policy.canManageAsset : true,
                            filterUser: userData.policy.hasOwnProperty('filterUser') ? userData.policy.filterUser : false,
                            canManageGeoxRules: userData.policy.hasOwnProperty('canManageGeoxRules') ? userData.policy.canManageGeoxRules : false,
                            canManageIntegrations: userData.policy.hasOwnProperty('canManageIntegrations') ? userData.policy.canManageIntegrations : false,
                            canManagePaginationAPI: userData.policy.hasOwnProperty('canManagePaginationAPI') ? userData.policy.canManagePaginationAPI : false,
                            canManageLabels: userData.policy.hasOwnProperty('canManageLabels') ? userData.policy.canManageLabels : false,
                        },
                        attached_labels_projects: userData.attached_labels_projects || [],
                        registrationDate: userData.registrationDate ? (new Date(userData.registrationDate)).toUTCString() : 'unknown',
                        lastLogin: userData.lastLogin ? (new Date(userData.lastLogin)).toUTCString() : 'unknown',
                    });
                    setProjects({ ...projects, retrieving: false })
                    //console.log(userData)
                    return userData
                })
                .catch(err => {
                    console.error('Error fetching user')
                    setSnack({ open: true, creationMessage: 'fetch user error. Check dynamo.' })
                    setPatchUsrMngmt({ ...patchUsrMngmt, fetched: false });
                })
        }
    }
    const handleProjectSelectRegister = (event, values) => {
        setUserMngmt({ ...userMngmt, selectedList: values });
    }
    const handleProjectSelectPatch = (event, values) => {
        setPatchUsrMngmt({ ...patchUsrMngmt, selectedList: values });
    }

    const handleResetUserPatch = () => {
        setPatchUsrMngmt({
            email: '',
            attached_projects: [],
            attached_labels_projects: [],
            selectedList: [],
            isAdmin: false,
            type: '',
            registrationDate: undefined,
            lastLogin: undefined,
            policy: {
                canDelete: false,
                canLaunch: false,
                canManageAsset: false,
                filterUser: false,
                canManageGeoxRules: false,
                canManageIntegrations: false,
                canManagePaginationAPI: false,
                canManageLabels: false,
            },
            isFetching: false,
            fetched: false,
            isPatching: false,
            patched: false,
            openDelete: false,
        })
    }
    const handleResetCustomerPatch = () => {
        setCustomerFilter({
            customer: '',
            isFetching: false,
            fetched: false,
            users: []
        })
        handleResetUserPatch()
    }

    const fetchCustomerUsers = async () => {
        setCustomerFilter({ ...customerFilter, isFetching: true });
        return axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`,
            {
                headers: {
                    'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                    "content-type": "application/json",
                    "Authorization": await getSessionIdToken(),

                    "customer": customerFilter.customer,
                    "action": 'fetch-customer'
                }

            })
            .then(response => {
                const users = response.data.users;
                setCustomerFilter({
                    ...customerFilter,
                    //selectedList: userData.attached_projects,
                    isFetching: false,
                    fetched: true,
                    users: users,

                });
                return users
            })
            .catch(err => {
                console.error('Error fetching user')
                setSnack({ open: true, creationMessage: 'fetch user error. Check dynamo.' })
                setCustomerFilter({ ...customerFilter, fetched: false, isFetching: false });
            })

    }
    const retrieveAllProjects = async () => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/projects-webapp`,
            {
                headers: {
                    'user_id': auth.userState.user,
                    "content-type": "application/json",
                    "Authorization": await getSessionIdToken(),
                    "type": 'project-list',
                }
            },
        )
            .then(response => {
                //console.log(response.data.projectsList.map(el => `${el.customer}/${el.project_name}`))
                const allProjects = response.data.projectsList || [];
                setProjects({
                    ...projects,
                    list: allProjects.filter(el => !el.is_labels).map(el => `${el.customer}/${el.project_name}`),
                    labelsProjectsList: allProjects.filter(el => el.is_labels).map(el => `${el.customer}/${el.project_name}`),
                    retrieving: false
                });
            })
            .catch(err => {
                console.error('Error fetching projects')
                setProjects({ ...projects, retrieving: false });
            })
    }

    const getUserInfo = async (email) => {
        return axios.get(`${process.env.REACT_APP_API_BASE_URL}/users`,
            {
                headers: {
                    'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                    "content-type": "application/json",
                    "Authorization": await getSessionIdToken(),
                    "userInfo_id": buildUsernameFromEmail(email), // lo user id è l'email con la chiocciola sostituita dal punto. per i primi utenti è solo la parte prima della chiocchiola
                    "email": email
                }

            })
    }

    const generatePassword = (length = 10) => {
        const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const lower = 'abcdefghijklmnopqrstuvwxyz';
        const numbers = '0123456789';
        const all = upper + lower + numbers;

        const arr = new Uint8Array(length);
        window.crypto.getRandomValues(arr);

        // garantisce almeno 1 maiuscola, 1 minuscola, 1 numero
        const pwd = [
            upper[arr[0] % upper.length],
            lower[arr[1] % lower.length],
            numbers[arr[2] % numbers.length],
            ...Array.from(arr.slice(3), n => all[n % all.length])
        ];

        // mescola
        for (let i = pwd.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [pwd[i], pwd[j]] = [pwd[j], pwd[i]];
        }

        return pwd.join('');
    }



    // register and patch
    const registerNewUser = async () => {

        setUserMngmt({ ...userMngmt, isCreating: true });

        //console.log('creatin user init', userMngmt)
        const password = generatePassword(10)


        axios.post(`${process.env.REACT_APP_API_BASE_URL}/register`,
            {
                user_id: buildUsernameFromEmail(userMngmt.email), //lo user id è sempre minuscolo, con punto al posto della chiocchiola, chiave dynamo
                email: userMngmt.email,
                customer: userMngmt.customer,
                isAdmin: userMngmt.isAdmin,
                policy: userMngmt.policy,
                type: userMngmt.type,
                password: password,
                attached_projects: userMngmt.selectedList,
                attached_labels_projects: userMngmt.attached_labels_projects || [],
            },
            {
                headers: {
                    'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                    "content-type": "application/json",
                    "Authorization": await getSessionIdToken(),
                }

            })
            .then(response => {
                //console.log(response.data);
                setSnack({ open: true, creationMessage: JSON.stringify(response.data) })
                setUserMngmt({ ...userMngmt, isCreating: false, created: true });
            })
            .catch(err => {
                console.error('Error registering user')
                setSnack({ open: true, creationMessage: JSON.stringify(err) })
                setUserMngmt({ ...userMngmt, isCreating: false });
            })
            .finally(() => {
                setUserMngmt({
                    ...userMngmt,
                    email: '',
                    isAdmin: false,
                    type: '',
                    policy: { canDelete: true, canLaunch: true, canManageAsset: true, filterUser: false, canManageGeoxRules: false, canManageIntegrations: false, canManagePaginationAPI: false, canManageLabels: false },
                    attached_labels_projects: [],
                    isCreating: false,
                    created: false,
                })
            })


    }

    const patchUser = async (action = 'patch') => {
        setPatchUsrMngmt({ ...patchUsrMngmt, isPatching: true });

        axios.patch(`${process.env.REACT_APP_API_BASE_URL}/users`,
            {
                userInfo_id: buildUsernameFromEmail(patchUsrMngmt.email),
                project_ids: patchUsrMngmt.selectedList,
                policy: patchUsrMngmt.policy,
                type: patchUsrMngmt.type,
                action,
                attached_labels_projects: patchUsrMngmt.attached_labels_projects || [],
                user_pool_id: REACT_APP_USER_POOL_ID || auth.userState.ssmParams.USER_POOL_ID
            },
            {
                headers: {
                    'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                    "content-type": "application/json",
                    "Authorization": await getSessionIdToken(),
                }

            })
            .then(() => {

                if (patchUsrMngmt.email === auth.userState.email) {
                    auth.setUserState({ ...auth.userState, attached_projects: patchUsrMngmt.selectedList.sort() })
                }
                setSnack({ open: true, creationMessage: patchUsrMngmt.selectedList.join(', ') })
            })
            .catch(err => {
                console.error('Error patching user')
                setSnack({ open: true, creationMessage: JSON.stringify(err) })
            })
            .finally(() => {
                handleResetUserPatch()
            })
    }


    // refresh al montaggio
    useEffect(() => {
        retrieveAllProjects();
    }, []);


    return (
        <div>
            <Grid
                container
                flexDirection={'row'}
                sx={{
                    justifyContent: "space-around",
                    alignItems: "center",
                    marginTop: '2em',
                    marginBottom: '2em',
                    marginLeft: '2em',
                    marginRight: '2em'
                }}
                rowSpacing={3}
                columnSpacing={3}
                columns={12}
            >
                <Grid size={12} >
                    <Item elevation={3} key='add-user'>
                        <Typography variant='h5' sx={{ marginBottom: '1em' }} >
                            <b>Register user</b>
                        </Typography>
                        <Stack direction='row' spacing={2} >
                            <TextField key='email'
                                label='email'
                                helperText='If the user is admin he can be attached to any project'
                                value={userMngmt.email}
                                size='small'
                                sx={{ width: '30%' }}
                                onChange={(event) => setUserMngmt({
                                    ...userMngmt,
                                    email: event.target.value
                                })}
                            />
                            <Autocomplete
                                disabled={projects.list.length === 0}
                                limitTags={1}
                                options={Array.from(new Set(projects.list.map(p => p.split('/').shift()))).sort()}
                                onChange={(event, value) => setUserMngmt({ ...userMngmt, customer: value })}
                                sx={{ width: '20%' }}
                                size='small'
                                renderInput={(params) => <TextField {...params} variant="outlined" label={projects.retrieving ? 'loading...' : 'customers'} placeholder="" />}
                            />

                        </Stack>
                        <Stack direction='column' spacing={2} sx={{ mt: '1em', width: '50%' }}>
                            <Autocomplete
                                multiple
                                disabled={projects.list.length === 0}
                                limitTags={5}
                                disableCloseOnSelect
                                options={projects.list.filter(p => userMngmt.isAdmin || p.split('/').shift() === userMngmt.customer)}
                                onChange={handleProjectSelectRegister}
                                size='small'
                                getOptionLabel={(option) => option}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" label={projects.retrieving ? 'loading...' : 'Pagination Projects'} placeholder="" />
                                )}
                            />
                            <Autocomplete
                                multiple
                                disabled={!userMngmt.email}
                                options={projects.labelsProjectsList || []}
                                value={userMngmt.attached_labels_projects || []}
                                onChange={(event, values) => setUserMngmt({ ...userMngmt, attached_labels_projects: values })}
                                size='small'
                                renderInput={(params) => <TextField {...params} variant="outlined" label="Labels Projects" placeholder="Select labels projects" />}
                            />
                        </Stack>

                        <Box>
                            <FormGroup>
                                <Autocomplete
                                    disabled={!userMngmt.email}
                                    limitTags={1}
                                    options={['administrator', 'billing', 'customer']}
                                    defaultValue={'customer'}
                                    value={userMngmt.type ? userMngmt.type : 'customer'}
                                    onChange={(event, value, reason) => setUserMngmt({
                                        ...userMngmt,
                                        isAdmin: value === 'administrator',
                                        type: value
                                    })}
                                    sx={{ width: '20%', mb: '1em', mt: '1em' }}
                                    size='small'
                                    renderInput={(params) => <TextField {...params} variant="outlined" label={'User Type'} placeholder="" />}
                                />
                                <Typography variant='body2' color={'primary'}>
                                    <b>User policy:</b>
                                </Typography>
                                <Select
                                    multiple
                                    size='small'
                                    value={POLICY_OPTIONS.filter(p => userMngmt.policy[p.key]).map(p => p.key)}
                                    disabled={!userMngmt.email}
                                    onChange={(event) => {
                                        const selected = event.target.value;
                                        const newPolicy = {};
                                        POLICY_OPTIONS.forEach(p => { newPolicy[p.key] = selected.includes(p.key); });
                                        setUserMngmt({ ...userMngmt, policy: newPolicy });
                                    }}
                                    input={<OutlinedInput />}
                                    renderValue={(selected) => selected.map(k => POLICY_OPTIONS.find(p => p.key === k)?.label).join(', ')}
                                    sx={{ minWidth: 300, width: '20%', mb: '1em', mt: '1em' }}
                                >
                                    {POLICY_OPTIONS.map(p => (
                                        <MenuItem key={p.key} value={p.key}>
                                            <Checkbox size='small' checked={userMngmt.policy[p.key]} />
                                            <ListItemText primary={p.label} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormGroup>
                        </Box>

                        <Button
                            disabled={userMngmt.email === '' || (userMngmt.selectedList.length === 0 && (userMngmt.attached_labels_projects || []).length === 0)}
                            loading={userMngmt.isCreating}
                            loadingPosition="start"
                            startIcon={<PersonAddAltIcon />}
                            variant="contained"

                            onClick={registerNewUser}
                            sx={{ marginTop: '1em' }}
                        >
                            Register
                        </Button>


                        <Snackbar
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            open={snack.open}
                            autoHideDuration={6000}
                            onClose={handleClose}
                            message={snack.creationMessage}
                            action={
                                <React.Fragment>
                                    <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </React.Fragment>
                            }

                        />

                    </Item>

                </Grid>


                <Grid size={12}>
                    <Item elevation={3} key='patch-user' >
                        <Typography variant='h5' sx={{ marginBottom: '1em' }} >
                            <b>Info / Patch user</b>
                        </Typography>
                        <Stack direction='row' spacing={2} alignItems='flex-start' sx={{ width: '100%' }}>
                            <Autocomplete
                                disabled={projects.list.length === 0}
                                limitTags={1}
                                options={Array.from(new Set(projects.list.map(p => p.split('/').shift()))).sort()}
                                onChange={handleCustomerFilter}
                                defaultValue={auth.userState.isAdmin ? 'pagination' : undefined}
                                sx={{ width: '13em', minWidth: '13em' }}
                                size='small'
                                renderInput={(params) => <TextField {...params} variant="outlined" label={projects.retrieving ? 'loading...' : 'customers'} placeholder="" />}
                            />


                            <Button
                                disabled={customerFilter.customer === ''}
                                loading={customerFilter.isFetching}
                                variant="contained"
                                onClick={fetchCustomerUsers}
                                sx={{ width: '10em', minWidth: '10em', }}
                            >
                                fetch users
                            </Button>


                            <Autocomplete
                                disabled={customerFilter.users.length === 0}
                                limitTags={1}
                                options={customerFilter.users}
                                getOptionLabel={(option) => option.email}
                                isOptionEqualToValue={(option, value) => option.email === value.email}
                                defaultValue={{ email: '' }}
                                value={{ email: patchUsrMngmt.email }}
                                onChange={handleSelectPathEmail}
                                sx={{ width: '50%', minWidth: '15em' }}
                                size='small'
                                renderInput={(params) => <TextField {...params} variant="outlined" label={customerFilter.isFetching ? 'loading...' : 'users'} placeholder="" />}
                            />

                        </Stack>
                        <Stack direction='column' spacing={2} sx={{ mt: '1em', width: '50%' }}>
                            <Autocomplete
                                multiple
                                disableCloseOnSelect
                                disabled={projects.list.length === 0 || patchUsrMngmt.email === ''}
                                limitTags={5}
                                options={projects.list}
                                value={patchUsrMngmt.selectedList}
                                onChange={handleProjectSelectPatch}
                                size='small'
                                getOptionLabel={(option) => option}
                                defaultValue={patchUsrMngmt.attached_projects}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" label={patchUsrMngmt.retrieving ? 'loading...' : 'Pagination Projects'} placeholder="" />
                                )}
                            />
                            <Autocomplete
                                multiple
                                disabled={!patchUsrMngmt.fetched}
                                options={projects.labelsProjectsList || []}
                                value={patchUsrMngmt.attached_labels_projects || []}
                                onChange={(event, values) => setPatchUsrMngmt({ ...patchUsrMngmt, attached_labels_projects: values })}
                                size='small'
                                renderInput={(params) => <TextField {...params} variant="outlined" label="Labels Projects" placeholder="Select labels projects" />}
                            />
                        </Stack>
                        <Box mt='1em' mb='0.5em'>
                            <Typography variant='body2' color={patchUsrMngmt.registrationDate ? 'primary' : 'lightGray'}>
                                <b>Registration date:</b> {patchUsrMngmt.registrationDate ? patchUsrMngmt.registrationDate : '...'}
                            </Typography>
                            <Typography variant='body2' color={patchUsrMngmt.lastLogin ? 'primary' : 'lightGray'}>
                                <b>Last login date:</b> {patchUsrMngmt.lastLogin ? patchUsrMngmt.lastLogin : '...'}
                            </Typography>
                        </Box>
                        <Box id='admin-check'>
                            <FormGroup>
                                <Autocomplete
                                    disabled={!patchUsrMngmt.fetched}
                                    limitTags={1}
                                    options={['administrator', 'billing', 'customer']}
                                    defaultValue={'customer'}
                                    value={patchUsrMngmt.type ? patchUsrMngmt.type : 'customer'}
                                    onChange={(event, value, reason) => setPatchUsrMngmt({
                                        ...patchUsrMngmt,
                                        isAdmin: value === 'administrator',
                                        type: value
                                    })}
                                    sx={{ width: '20%', mb: '1em', mt: '1em' }}
                                    size='small'
                                    renderInput={(params) => <TextField {...params} variant="outlined" label={'User Type'} placeholder="" />}
                                />
                                <Typography variant='body2' color={'primary'}>
                                    <b>User policy:</b>
                                </Typography>
                                <Select
                                    multiple
                                    size='small'
                                    value={POLICY_OPTIONS.filter(p => patchUsrMngmt.policy[p.key]).map(p => p.key)}
                                    disabled={!patchUsrMngmt.fetched}
                                    onChange={(event) => {
                                        const selected = event.target.value;
                                        const newPolicy = {};
                                        POLICY_OPTIONS.forEach(p => { newPolicy[p.key] = selected.includes(p.key); });
                                        setPatchUsrMngmt({ ...patchUsrMngmt, policy: newPolicy });
                                    }}
                                    input={<OutlinedInput />}
                                    renderValue={(selected) => selected.map(k => POLICY_OPTIONS.find(p => p.key === k)?.label).join(', ')}
                                    sx={{ minWidth: 300, width: '20%', mb: '1em', mt: '1em' }}
                                >
                                    {POLICY_OPTIONS.map(p => (
                                        <MenuItem key={p.key} value={p.key}>
                                            <Checkbox size='small' checked={patchUsrMngmt.policy[p.key]} />
                                            <ListItemText primary={p.label} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormGroup>
                        </Box>
                        <Stack direction='row' spacing={2} mt='1em'>
                            <Button
                                disabled={patchUsrMngmt.email === ''}
                                loading={patchUsrMngmt.isPatching}
                                loadingPosition="start"
                                startIcon={<PersonAddAltIcon />}
                                variant="contained"
                                onClick={() => patchUser('patch')}
                            >
                                Patch
                            </Button>
                            <Button
                                disabled={patchUsrMngmt.email === '' || patchUsrMngmt.selectedList.length === 0}
                                loading={patchUsrMngmt.isPatching}
                                loadingPosition="start"
                                startIcon={<PersonRemoveIcon />}
                                variant="contained"
                                color='error'
                                onClick={handleClickOpen}
                            >
                                Delete
                            </Button>
                            <Dialog
                                open={patchUsrMngmt.openDelete}
                                onClose={handleDisagree}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">Delete user</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure to delete {patchUsrMngmt.email}?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleDisagree} color="primary">
                                        Disagree
                                    </Button>
                                    <Button onClick={() => handleAgree('delete')} color="primary" autoFocus>
                                        Agree
                                    </Button>
                                </DialogActions>
                            </Dialog>

                        </Stack>
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            open={snack.open}
                            autoHideDuration={6000}
                            onClose={handleClose}
                            message={snack.creationMessage}
                            action={
                                <React.Fragment>
                                    <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </React.Fragment>
                            }

                        />

                    </Item>
                </Grid>


                <Grid size={12}>
                    <Item elevation={3} key='project-parameters' >
                        <Typography variant='h5' sx={{ marginBottom: '1em' }} >
                            <b>Project Parameters</b>
                        </Typography>
                        <ProjectParameters auth={auth} projects={projects} />
                    </Item>
                </Grid>

                <Grid size={12}>
                    <Item elevation={3} key='project-parameters' >
                        <Typography variant='h5' sx={{ marginBottom: '1em' }} >
                            <b>Project Management</b>
                        </Typography>
                        <ProjectDisable auth={auth} projects={projects} />
                    </Item>
                </Grid>
            </Grid>
        </div >
    )


}







